module.exports = __webpack_public_path__ + "static/standalone/img/protect-cash.0f5ddd0b.svg";